import { SalesSummaryPrint } from './sales-summary-print';
import { OrderInvoicePrinting } from './order-invoice-printing';

import { usePrintManagement } from './usePrintManagement';

export function PrintManagement() {
  const { enableOrderToPrint, salesSummaryPrint } = usePrintManagement();

  return (
    <aside aria-label='print-management' style={{ fontFamily: 'Inconsolata' }}>
      {enableOrderToPrint && <OrderInvoicePrinting />}
      {salesSummaryPrint && <SalesSummaryPrint />}
    </aside>
  );
}
